// extracted by mini-css-extract-plugin
export default {"login-page":"LoginPage_login-page__bfji0","login-rect":"LoginPage_login-rect__L3Khr","login-title":"LoginPage_login-title__kbE5c","error-message":"LoginPage_error-message__Jwd4h"};